<template>
    <div
        class="CriterionSettingsRow"
        :class="{
            'CriterionSettingsRow--nonSubstitutable':
                !isArrayWithObject(schema) &&
                !schemaHaveSubstitutableSchemaWithValue(schema),
            'CriterionSettingsRow--substitutable':
                schemaHaveSubstitutableSchemaWithValue(schema),
            'CriterionSettingsRow--conditionSets':
                isKeyConditionSets(keyName),
        }"
    >
        <slot />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import JsonSchema from '@evidentid/json-schema/interfaces/JsonSchema';
    import { isArray, isObject } from '@evidentid/json-schema/schemaChecks';

    import { GeneralAggregateLimitReferences } from '@/modules/decisioning-criteria/types';
    import { isSubstitutableSchema } from '@/modules/decisioning-criteria/utils/isSubstitutableSchema';
    import { schemaHaveSubstitutableSchemaWithValue } from '@/modules/decisioning-criteria/utils/schemaHaveSubstitutableSchemaWithValue';

    export default defineComponent({
        name: 'CriterionSettingsRow',
        props: {
            schema: {
                type: Object as PropType<JsonSchema | undefined>,
                default: () => undefined as JsonSchema | undefined,
            },
            keyName: {
                type: String as PropType<string>,
                default: '',
            },
        },
        methods: {
            isArrayWithObject(schema: JsonSchema | undefined): boolean {
                if (!schema) {
                    return false;
                }
                return isArray(schema) && isObject(schema.items as JsonSchema);
            },
            isSubstitutableSchema,
            schemaHaveSubstitutableSchemaWithValue,
            isKeyConditionSets(key: string | undefined) {
                if (!key) {
                    return false;
                }
                return key === GeneralAggregateLimitReferences.conditionSets;
            },
        },
    });
</script>
